<template>
  <div v-if="clientSid">
    <v-stepper v-model="currentStep" editable flat>
      <v-stepper-header>
        <v-stepper-item title="Prepare" :value="1" :complete="currentStep > 1" color="primary" />
        <v-divider />
        <v-stepper-item title="Migrate" :value="2" :complete="currentStep > 2" color="primary" />
        <v-divider />
        <v-stepper-item title="Configure" :value="3" color="primary" />
      </v-stepper-header>

      <v-stepper-window class="ma-4">
        <v-stepper-window-item :value="1">
          <client-hub-prepare :client-sid="clientSid" />
        </v-stepper-window-item>

        <v-stepper-window-item :value="2">
          <client-hub-upload :client-sid="clientSid" />
        </v-stepper-window-item>

        <v-stepper-window-item :value="3">
          <client-hub-config :client-sid="clientSid" />
        </v-stepper-window-item>
      </v-stepper-window>
    </v-stepper>
  </div>
</template>

<script>
import ClientHubPrepare from './ClientHubPrepare';
import ClientHubUpload from './ClientHubUpload';
import ClientHubConfig from './ClientHubConfig';

export default {
  name: 'ClientHubMigration',
  components: {
    ClientHubPrepare,
    ClientHubUpload,
    ClientHubConfig
  },
  props: {
    clientSid: { type: String, required: false, default: '' },
    activeStep: { type: Number, required: false, default: 1 }
  },

  emits: ['update:activeStep'],

  computed: {
    currentStep: {
      get() {
        return this.activeStep;
      },
      set(val) {
        this.$emit('update:activeStep', val);
      }
    }
  }
};
</script>
